import { Action } from '../store'
import { ConfigOptions } from '../../common/app-config'
import { apiRequest } from '../../common/api'
import { action as makeAction } from 'typesafe-actions'
import { config } from '../../app-config'

// types
export const SET_CONFIG = 'ui/SET_CONFIG'
export const APP_CONFIG_FETCH_START = 'APP_CONFIG_FETCH_START'
export const APP_CONFIG_FETCH_OK = 'APP_CONFIG_FETCH_OK'
export const APP_CONFIG_FETCH_ERROR = 'APP_CONFIG_FETCH_ERROR'

export interface UiState {
  readonly wasFetched: boolean
  readonly wasError: boolean
  readonly config: ConfigOptions
}

// actions
export const setConfig = (config: ConfigOptions) => {
  return {
    type: SET_CONFIG,
    payload: config,
  }
}
// reducer
const initialState = {
  wasFetched: false,
  wasError: false,
  config: {
    appName: '',
    appKey: '',
    appDate: '',
    appVersion: '0.0.0',
    domain: '',
    appUrl: '',
    recapatchaPublicKey: '',
  },
}

type AppconfigResponse = { 'hydra:member': { key: string; value: string }[] }

const getConfigsFromArray = (
  arr: { key: string; value: string }[],
): ConfigOptions => {
  const findByKey = (
    key: string,
    arr: { key: string; value: string }[],
  ): string => {
    return arr
      .filter(el => el.key === key)
      .reduce((_, current) => current.value, '')
  }
  let ret = {
    appName: findByKey('app_name', arr),
    appKey: findByKey('appKey', arr),
    appDate: findByKey('app_version_date', arr),
    appVersion: findByKey('app_version', arr),
    domain: findByKey('domain', arr),
    appUrl: findByKey('appUrl', arr),
    recapatchaPublicKey: findByKey('recapatcha_public_key', arr),
  }
  return ret
}

export const fetchAppConfig = () => dispatch => {
  dispatch(fetchAppConfigStart())
  apiRequest
    .get<AppconfigResponse>(config.api.urls.list())
    .then(response => {
      dispatch(
        fetchAppConfigOk(getConfigsFromArray(response.data['hydra:member'])),
      )
    })
    .catch(err => {
      dispatch(fetchAppConfigError()) // TODO dodać err
    })
}

export const fetchAppConfigOk = (config: ConfigOptions) =>
  makeAction(APP_CONFIG_FETCH_OK, { config })
export const fetchAppConfigStart = () => makeAction(APP_CONFIG_FETCH_START, {})
export const fetchAppConfigError = () => makeAction(APP_CONFIG_FETCH_ERROR, {})

export const uiReducer = (state: UiState = initialState, action: Action) => {
  switch (action.type) {
    case SET_CONFIG:
      return { ...state, config: { ...action.payload } }
    case APP_CONFIG_FETCH_OK:
      return {
        ...state,
        wasFetched: true,
        config: action.payload.config,
      }
    case APP_CONFIG_FETCH_ERROR:
      return {
        ...state,
        wasFetched: true,
        wasError: true,
      }
    default:
      return state
  }
}
